/** True when `git diff --numstat` marks a path as binary (`-` in add/del columns). */
export function isBinaryNumstatLine(line: string): boolean {
  const parts = line.split('\t');
  if (parts.length < 3) return false;
  return parts[0] === '-' || parts[1] === '-';
}
